<template>
    <div class="container">
        <div class="top">
            <videosrc></videosrc>
            <div class="navbar">
                <div id="1" :class="{'is-selected-color':$store.state.selected==1}"  @touchstart.stop.prevent="changeSelected(1)" @click="changeSelected(1)">
                    <span> {{$store.state.tabar[1]}}({{$store.state.tabCount[1]}})</span>
                    <div :class="{'is-selected':$store.state.selected==1}"></div>
                </div>
                <div id="2" :class="{'is-selected-color':$store.state.selected==2}" @touchstart.stop.prevent="changeSelected(2)" @click="changeSelected(2)">
                    <span> {{$store.state.tabar[2]}}({{$store.state.tabCount[2]}})</span>
                    <div :class="{'is-selected':$store.state.selected==2}"></div>
                </div>
                <div id="3" :class="{'is-selected-color':$store.state.selected==3}" @touchstart.stop.prevent="changeSelected(3)" @click="changeSelected(3)">
                    <span> {{$store.state.tabar[3]}}({{$store.state.tabCount[3]}})</span>
                    <div :class="{'is-selected':$store.state.selected==3}"></div>
                </div>
                <div id="4" :class="{'is-selected-color':$store.state.selected==4}" @touchstart.stop.prevent="changeSelected(4)" @click="changeSelected(4)">
                    <span> {{$store.state.tabar[4]}}({{$store.state.tabCount[4]}})</span>
                    <div :class="{'is-selected':$store.state.selected==4}"></div>
                </div>
            </div>
        </div>
        <div class="bottom">
            <div style="width:100%;" :style="{height:$store.state.videoTabHeight+'px'}"></div>
            <div v-if="$store.state.selected==1">
                <celllist :defList="$store.state.defList" :isShow="$store.state.isShow1"></celllist>
            </div>
            <div v-else-if="$store.state.selected==2">
                <celllist  :defList="$store.state.twoList" :isShow="$store.state.isShow2"></celllist>
            </div>
            <div  v-else-if="$store.state.selected==3">
                <celllist :defList="$store.state.threeList" :isShow="$store.state.isShow3"></celllist>
            </div>
            <div v-else-if="$store.state.selected==4">
                <celllist :defList="$store.state.fourList" :isShow="$store.state.isShow4"></celllist>
            </div>
        </div>
    </div>
</template>

<script>
import {isWexinmobile,toast} from '@/utils/utils.js'
import https from '../https.js'
import { Indicator } from 'mint-ui';
import backhome from './common/backHome'
import videosrc from './common/video'
import celllist from './common/cellList'
import beian from "./common/footer"
export default {
  data () {
    return {
        tabar:[],
      clientHeight:0,//可视区的高度
      scrollTop:0,//滚动条滚动时，距离顶部的距离
      scrollHeight:0,//滚动条的总高度
      
      upShow:true,

      imgURL:"",//分享缩略图

      n:0,
      timer:null
    }
  },
  created(){
      document.title=this.$store.state.title2;
      var cellWidth=document.body.clientWidth;
      this.$store.state.videoTabHeight=Math.floor( cellWidth*368/624)+45;   //视频比例624:368,tab高24
      sessionStorage.setItem("lToD",true);
      this.$store.state.totleIsShow=true;
        
          this.$store.state.isShow1=false;
          this.$store.state.isShow2=false;
          this.$store.state.isShow3=false;
          this.$store.state.isShow4=false;
          this.$store.state.page1=1;
          this.$store.state.page2=1;
          this.$store.state.page3=1;
          this.$store.state.page4=1;
          this.$store.state.defList="";
          this.$store.state.twoList="";
          this.$store.state.threeList="";
          this.$store.state.fourList="";
          this.$store.state.selected=1;
          this.changeSelected();  //传值为空加载默认列表
      


      this.$once('hook:beforeDestroy', () => {            
        clearInterval(this.overtimer);
        this.overtimer = null;
        })
},
  mounted(){
        window.addEventListener('scroll',this.listenerFunction)
  },
  updated(){
        document.title=this.$store.state.title2;
  },
  destroyed() {     //销毁
       window.removeEventListener("scroll",this.listenerFunction);
  },
  methods:{
      listenerFunction(){
            this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop;//可视区的高度
            this.clientHeight = document.documentElement.clientHeight || document.body.clientHeight;//滚动条滚动时，距离顶部的距离
            this.scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;//滚动条的总高度
           if((this.$store.state.selected==1&&this.$store.state.isShow1==true)||(this.$store.state.selected==2&&this.$store.state.isShow2==true)||(this.$store.state.selected==3&&this.$store.state.isShow3==true)||(this.$store.state.selected==4&&this.$store.state.isShow4==true)){
               return;
           }else if(this.scrollTop+this.clientHeight>=this.scrollHeight){
                Indicator.open({
                    text: '加载中...',
                    spinnerType: 'fading-circle'
                });
                this.timer=setTimeout(()=>{   //延迟500ms加载数据
                    this.loadMore();
                    this.n++;
                    console.log("第"+this.n+"次加载")
                },500)
           }
      },
      //切换navbar加载不同列表
      changeSelected(n){
          var that=this;
        this.$store.state.category_id=this.$route.query.id
        if(n==null){
            var obj={"category_id":this.$store.state.category_id,"page":"1","level_category_id":this.$store.state.selected}
            var videoId=this.$route.query.videoId;
            https.fetchGet("Article/index",obj)
                    .then(result=>{
                        this.$store.state.tabar=result.data.data.level_category_id_arr;
                        // tab对应数量
                        this.$store.state.tabCount=result.data.data.level_category_cnt_info
                        // 默认title
                        this.$store.state.title2=result.data.data.category_info.category_name;
                        // 默认视频
                        if(videoId==null){
                            this.$store.state.videoMsg=result.data.data.def_mov;
                        }else{
                            https.fetchGet("Article/index",{id:videoId})
                            .then(result=>{
                                //将数据传给video组件
                                this.$store.state.videoMsg=result.data.data;
                            })  
                        }
                        // 默认列表
                        if(result.data.data.list.length<10){//每页10条数据
                            this.$store.state.isShow1=true;
                        }
                        this.$store.state.defList=result.data.data.list;
                    })
        }else{
            this.$store.state.selected=n;
            var obj={"category_id":this.$store.state.category_id,"page":"1","level_category_id":this.$store.state.selected};
            if(n==1){
                return;
            }else if(n==2){
                if(this.$store.state.twoList==""){
                    https.fetchGet("Article/index",obj)
                    .then(result=>{
                        // 列表(正文)
                        if(result.data.data.list.length<10){//每页10条数据
                            this.$store.state.isShow2=true;
                        }
                        this.$store.state.twoList=result.data.data.list
                    })
                }
            }else if(n==3){
                 if(this.$store.state.threeList==""){
                    https.fetchGet("Article/index",obj)
                        .then(result=>{
                            // 列表(视频)
                            if(result.data.data.list.length<10){//每页10条数据
                                this.$store.state.isShow3=true;
                            }
                            this.$store.state.threeList=result.data.data.list
                        })
                 }
            }else if(n==4){
                if(this.$store.state.fourList==""){
                    https.fetchGet("Article/index",obj)
                        .then(result=>{
                            // 列表(拓展)
                            if(result.data.data.list.length<10){//每页10条数据
                                this.$store.state.isShow4=true;
                            }
                            this.$store.state.fourList=result.data.data.list
                        })
                }
            }
        };
      },
        //加载更多
        loadMore(){
            this.$store.state.category_id=this.$route.query.id;
            var page;
            if(this.$store.state.selected==1){//准备
                this.$store.state.page1++;
                page=this.$store.state.page1;
            }else if(this.$store.state.selected==2){//正文
                 this.$store.state.page2++;
                page=this.$store.state.page2;
            }else if(this.$store.state.selected==3){//视频
                 this.$store.state.page3++;
                page=this.$store.state.page3;
            }else if(this.$store.state.selected==4){//拓展
                 this.$store.state.page4++;
                page=this.$store.state.page4;
            }
            
            if(page==null){
                return
            }
            var obj={"category_id":this.$store.state.category_id,"page":page,"level_category_id":this.$store.state.selected};
             https.fetchPost("Article/index",obj)
                .then(result=>{
                    if(this.$store.state.selected==1){
                        if(result.data.data.list.length<10){//每页10条数据
                            this.$store.state.isShow1=true;
                        }
                        this.$store.state.defList=this.$store.state.defList.concat(result.data.data.list) ;
                    }else if(this.$store.state.selected==2){
                        if(result.data.data.list.length<10){//每页10条数据
                                this.$store.state.isShow2=true;
                            }
                            this.$store.state.twoList=this.$store.state.twoList.concat(result.data.data.list) ;
                    }else if(this.$store.state.selected==3){
                        if(result.data.data.list.length<10){//每页10条数据
                                this.$store.state.isShow3=true;
                            }
                            this.$store.state.threeList=this.$store.state.threeList.concat(result.data.data.list) ;
                    }else if(this.$store.state.selected==4){
                        if(result.data.data.list.length<10){//每页10条数据
                                this.$store.state.isShow4=true;
                            }
                            this.$store.state.fourList=this.$store.state.fourList.concat(result.data.data.list) ;
                    }
                    
                })
        },
  },
 
   components:{
    "backhome":backhome,
    "celllist":celllist,
    "videosrc":videosrc,
    "beian":beian,
  },
  computed:{
       defList(){
           return this.$store.state.defList
       },
        twoList(){
           return this.$store.state.twoList
       },
        threeList(){
           return this.$store.state.threeList
       },
        fourList(){
           return this.$store.state.fourList
       },
  },
  watch:{
      defList(){
          Indicator.close();
      },
      twoList(){
          Indicator.close();
      },
      threeList(){
          Indicator.close();
      },
      fourList(){
          Indicator.close();
      }
  }
}
</script>

<style scoped>
    .container{
        position:relative;
    }
    .top{
        position:fixed;
        z-index: 1;
        top:0;
        background: #fff;
        width: 100%;
        max-width: 640px;
    }
    .navbar{
        display:flex;
        justify-content: space-between;
        font-size:15px;
        height:45px;
        background:#fff;
        padding: 0 14px;
        box-shadow:0px 0px 21px 0px rgba(79,116,255,0.18)
    }
    .navbar>div{
        height:100%;
        width:25%;
        line-height: 100%;
        /* display: flex;
        align-items: center;
        justify-content: center; */
        cursor: pointer;
    }
    .is-selected-color{
        color:#00878b;
    }
    .is-selected{
        border-bottom:3px solid #00878b;
        color:#00878b;
        width:50%;
        margin:0 auto;
    }
    .navbar>div>span{
        height:100%;
        line-height: 45px;
    }
    .bottom{
        /* height:100vh; */
        background:#fff;
        padding: 0px 14px;
    }
</style>



// WEBPACK FOOTER //
// src/components/list.vue